<template>
  <v-flex :class="input.mandatory === 'yes' && input.continued === 'yes' ? // if mandatory + continued attr
                  'question-inputs pb-0 pt-7' : input.mandatory === 'yes' ? // if mandatory
                  'question-inputs py-5 pt-7' : input.continued ? // if continued attr
                  'question-inputs pb-3 pt-5' : input.padding ? // if padding attr
                  'question-inputs pb-5 pt-0' : 'question-inputs py-5'">

    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>

    <v-file-input
      v-model="value"
      @change="onChange"
      :label="unescaped(input[`label_${$i18n.locale}`])"
      prepend-inner-icon="icon-document files-icon"
      prepend-icon=""
      clear-icon="icon-delete delete-icon"
      clearable
      truncate-length
      outlined
      hide-details
      :placeholder="input.answer ? input.answer : null"
      :required="input.mandatory === 'yes' ? 'required' : false"
      :aria-required="input.mandatory === 'yes' ? 'required' : false"
      accept="application/vnd.sealed.doc,.doc,.docx, application/pdf,.pdf, application/vnd.sealed.xls,.xls,.xlsx, application/vnd.sealed.ppt,.ppt,.pptx, image/jpg, image/jpeg, image/png, image/bmp, image/gif, image/tiff, audio/mpeg3, .mp3, .wav, video/mp4, video/mpeg,.mpeg, .avi, video/vnd.sealedmedia.softseal.mov,.mov, 	application/zip, application/vnd.rar,.rar, application/gzip,.gz"
    ></v-file-input>
    <small
      v-if="input.mandatory === 'yes'"
      v-html="`(${$t('inputs.mandatory')})`"
      class="mandatory-label"
    ></small>
    <small class="pl-8 d-block">
      <span
        v-if="input[`text_${$i18n.locale}`]"
        :class="img ? 'd-block mb-3' : 'd-block'">
          <pre v-html="input[`text_${$i18n.locale}`]"></pre>
      </span>
      <span v-if="img && img !== null && img !== 'null' && input.answer" style="
                        position: relative;
                        display: inline-block;">

        <v-img
          v-if="!mimeType && img"
          :src="img"
          aspect-ratio="1"
          max-width="100"
          max-height="100"
          width="100"
          height="100">
        </v-img>
        <v-img
          v-if="mimeType"
          :src="getMimeType"
          aspect-ratio="1"
          max-width="100"
          max-height="100"
          width="100"
          height="100"
          class="mime-type"
          style="background-color: #f3f4f9;">
        </v-img>

        <span style="
                position: absolute;
                display: block;
                top: 0; right: 0;">
          <button
            class="pa-1"
            @click="deleteFile">
            <v-icon color="error" size="11">icon-delete</v-icon>
          </button>
        </span>
      </span>
    </small>
    <!-- <div v-if="input.mandatory === 'yes'" class="mt-3 pl-7">
      <v-checkbox
        v-model="derogation"
        hide-details
        :label="$t('inputs.exemption')"
        @change="checkDerogation"
      ></v-checkbox>
      <div class="mb-5"></div>
      <v-textarea
        v-if="openDerogation"
        v-model="textDerogation"
        @change="onDeragation"
        outlined
        hide-details
        :label="$t('inputs.exemption-label')"
        clear-icon="icon-delete delete-icon"
        clearable
        required
        aria-required="true"
        :rules="[rules.required]"
      ></v-textarea>
    </div> -->
  </v-flex>
</template>

<script>
/* eslint-disable */
import { delegateRecord } from '@/js/delegate/delegateRecord'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'
import { mimeTypes } from '@/js/utils/mime-types'
import HTTPresponse from '@/components/app/HTTPresponse'
// import { recordDerogation } from '@/js/survey/recordDerogation'

export default {
  props: {
    input: Object|Array,
    collaboratorid: String,
    collaborationkey: String,
    answerid: String,
    path: String
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      value: [],
      img: null,
      mimeType: '',
      httpalert: false
      // derogation: this.input.derogation ? true : false,
      // openDerogation: this.input.derogation ? true : false,
      // textDerogation: this.input.derogation ? this.input.derogation : '',

      // rules: {
      //   required: value => !!value || 'Required.'
      // }
    }
  },
  computed: {
    getMimeType() {
      if (this.mimeType) {
        return `${require('@/assets/images/files/'+String(this.mimeType))}`
      } else { return require('@/assets/images/files/icon-doc.svg') }
    }
  },

  methods: {
    onChange () {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      // call API to record an answer

      if (this.value === '' || this.value === [] ||
          this.value === undefined || this.value === null ||
          this.value.length === 0) { this.deleteFile(); return }

      const params = {
        method: 'get',
        option: 'json+file',
        answerid: this.answerid,
        collaboratorid: this.collaboratorid,
        collaborationkey: this.collaborationkey,
        moduleid: this.input.id,
        path: `${this.path}|${this.input.id}`,
        value: this.value
      }
      delegateRecord(params)
        .then(() => this.$emit('inputUpdate'))
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    // onDeragation () {
    //   if (!this.$store.getters['auth/isAuthenticated']) return
    //   // call API to record an answer

    //   const params = {
    //     option: this.derogation == '' || this.derogation == undefined ||
    //            this.derogation == null || this.derogation == false ||
    //            this.textDerogation == '' || this.textDerogation == undefined ||
    //            this.textDerogation == null || this.textDerogation == false ? 'delete' : 'json',
    //     answerid: this.answerid,
    //     moduleid: this.input.id,
    //     path: `${this.path}|${this.input.id}`,
    //     value: (this.derogation == '' || this.derogation == undefined ||
    //            this.derogation == null || this.derogation == false) &&
    //            (this.textDerogation == '' || this.textDerogation == undefined ||
    //            this.textDerogation == null || this.textDerogation == false) ? '' : this.textDerogation,
    //     key: this.$store.state.auth.token
    //   }

    //   recordDerogation(params)
    //     .then(response => this.$emit('inputUpdate'))
    //     .catch(error => console.log(error))
    // },

    // checkDerogation () {
    //   this.openDerogation = !this.openDerogation
    //   if (this.openDerogation == false) {
    //     this.textDerogation = ''
    //     this.onDeragation()
    //   }
    // },

    deleteFile () {
      this.value = null
      this.img = null
      const params = {
        method: 'get',
        option: 'file+delete',
        answerid: this.answerid,
        collaboratorid: this.collaboratorid,
        collaborationkey: this.collaborationkey,
        moduleid: this.input.id,
        path: `${this.path}|${this.input.id}`,
        value: this.value
      }
      delegateRecord(params)
        .then(() => this.$emit('inputUpdate'))
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    unescaped (string) {
      var txt = document.createElement('textarea')
      txt.innerHTML = string
      return txt.value
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return
    // init upload input value if encoded answer exist
    if (this.input.type === 'upload' &&
        this.input.answer !== '' &&
        this.input.answer !== undefined &&
        this.input.answer !== 'undefined' &&
        this.input.answer !== null &&
        this.input.answer !== 'null' &&
        this.input.answer !== [] &&
        this.answerid) {

      // console.log(this.input)
      const img = `${randomBaseUrl(0, 3)}${process.env.VUE_APP_DELEGATE_GET_FILE_SURVEY_ENDPOINT}?valid=${encodeURIComponent(this.$route.params.collaboratorid)}&answerid=${encodeURIComponent(this.answerid)}&moduleid=${this.input.id}`
      mimeTypes(img)
        .then(response => {
          if (response) {this.mimeType = response}
          else {this.img = img}
        })

      // if (this.input.answer) {
      //   let illu = this.input.answer
      //   if (illu.includes('bin/')) illu = process.env.VUE_APP_API_ENDPOINT + illu.replace('bin/', '')
      //   this.img = illu
      // }
      // console.log(this.img)
    }
  },

  updated () {
    // if (!this.$store.getters['auth/isAuthenticated']) return
    // init upload input value if encoded answer exist
    if (this.input.type === 'upload' &&
        this.input.answer !== '' &&
        this.input.answer !== undefined &&
        this.input.answer !== 'undefined' &&
        this.input.answer !== null &&
        this.input.answer !== 'null' &&
        this.input.answer !== [] &&
        this.answerid) {

      const img = `${randomBaseUrl(0, 3)}${process.env.VUE_APP_DELEGATE_GET_FILE_SURVEY_ENDPOINT}?valid=${encodeURIComponent(this.$route.params.collaboratorid)}&answerid=${encodeURIComponent(this.answerid)}&moduleid=${this.input.id}`
      mimeTypes(img)
        .then(response => {
          if (response) {this.mimeType = response}
          else {this.img = img}
        })

      // if (this.input.answer) {
      //   let illu = this.input.answer
      //   if (illu.includes('bin/')) illu = process.env.VUE_APP_API_ENDPOINT + illu.replace('bin/', '')
      //   this.img = illu
      // }
    }
  }
}
</script>
